import { GroupsConstants } from './GroupsConstants';
export class GroupsUtils {
}
GroupsUtils.filterGroupIdentitySuffix = (groupId) => {
    return groupId.replace(GroupsConstants.GROUPS_IDENTITY_SUFFIX, '');
};
GroupsUtils.addGroupIdentitySuffix = (groupId) => {
    return `${groupId}${GroupsConstants.GROUPS_IDENTITY_SUFFIX}`;
};
